import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { CurrentUserProvider, QAccountAccessProvider, QualioQThemeProvider } from '@qualio/ui-components';
import { CurrentUser } from '@qualio/ui-components/lib/types/CurrentUser';
import { medtechApiClient } from '../services/axios';

type GlobalProviderProps = {
  currentUser: CurrentUser;
  children?: React.ReactNode;
};

export const GlobalProvider: React.FC<GlobalProviderProps> = ({ currentUser, children }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <CurrentUserProvider user={currentUser}>
        <QualioQThemeProvider>
          <QAccountAccessProvider mtbeClient={medtechApiClient}>{children}</QAccountAccessProvider>
        </QualioQThemeProvider>
      </CurrentUserProvider>
    </QueryClientProvider>
  );
};
